import type { MeasurementRecord } from "../../../web-app";
import {
  DELETE_MEASUREMENT,
  HYDRATE_MEASUREMENTS,
  MEASUREMENT_SAVE_FAILURE,
  MEASUREMENT_SAVE_SUCCESS,
  UPSERT_MEASUREMENT,
} from "../types";

export interface MeasurementsState {
  records: MeasurementRecord[];
  saveSubmitting: boolean;
  lastSaveSuccessAt: number;
}

const initialState: MeasurementsState = {
  records: [],
  saveSubmitting: false,
  lastSaveSuccessAt: 0,
};

type MeasurementsAction =
  | { type: typeof HYDRATE_MEASUREMENTS; records: MeasurementRecord[] }
  | { type: typeof UPSERT_MEASUREMENT; record: MeasurementRecord; fromModal?: boolean }
  | { type: typeof MEASUREMENT_SAVE_SUCCESS }
  | { type: typeof MEASUREMENT_SAVE_FAILURE }
  | { type: typeof DELETE_MEASUREMENT; id: string };

const measurementsReducer = (
  state = initialState,
  action: MeasurementsAction,
): MeasurementsState => {
  switch (action.type) {
    case HYDRATE_MEASUREMENTS:
      return { ...state, records: action.records };
    case UPSERT_MEASUREMENT: {
      const index = state.records.findIndex((record) => record.id === action.record.id);
      const records =
        index === -1
          ? [...state.records, action.record]
          : state.records.map((record, i) => (i === index ? action.record : record));
      return {
        ...state,
        records,
        saveSubmitting: action.fromModal ? true : state.saveSubmitting,
      };
    }
    case MEASUREMENT_SAVE_SUCCESS:
      return { ...state, saveSubmitting: false, lastSaveSuccessAt: Date.now() };
    case MEASUREMENT_SAVE_FAILURE:
      return { ...state, saveSubmitting: false };
    case DELETE_MEASUREMENT:
      return { ...state, records: state.records.filter((record) => record.id !== action.id) };
    default:
      return state;
  }
};

export default measurementsReducer;
